module.exports = __webpack_public_path__ + "static/img/changguan-6.97dc26a4.png";